export default __webpack_public_path__ + "0127dedc9c68f6580f2950df61e046b9.png";